import { ReactNode } from 'react'

type SectionHeaderProps = {
  title: ReactNode
  subtitle?: ReactNode
  className?: string
}

export function SectionHeader({
  title,
  subtitle,
  className = '',
}: SectionHeaderProps) {
  return (
    <div className={`space-y-2 pl-0 md:pl-6 lg:pl-[110px] ${className}`}>
      <h2 className='font-allround text-kuma-gris leading-tight tracking-tight text-3xl sm:text-4xl md:text-heading-2'>
        {title}
      </h2>

      {subtitle && (
        <p className='text-body text-kuma-gris/80 max-w-[600px]'>{subtitle}</p>
      )}
    </div>
  )
}
